<template>
    <b-form class="mt-4" id="comment-form" @submit.stop.prevent="onSubmit()">
        <b-form-group
            id="input-group-comment-body"
            label="Nuevo Comentario:"
            label-class="h5"
            label-for="input-comment-body"
        >
            <quillEditor v-model="form.body" :options="editorOptions" :disabled="formDisabled" />
        </b-form-group>

        <div class="text-center pt-2">
            <b-button
                type="submit"
                variant="primary"
                size="lg"
                :disabled="formDisabled || $v.form.$invalid"
            >
                Agregar
            </b-button>
        </div>

    </b-form>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import { quillEditor } from 'vue-quill-editor' // WYSIWYG Rich text editor
import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'CommentCreateModal',
    components: {
        quillEditor
    },
    data () {
        return {
            editorOptions: {
                placeholder: 'Inserte comentario',
                modules: {
                    toolbar: [['bold', 'italic', 'underline', 'strike'], ['link']]
                }
            },
            formDisabled: false,
            form: {
                body: ''
            }
        }
    },
    validations: {
        form: {
            body: {
                required
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedForumPostObject'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        disableOkButton () {
            return this.formDisabled || this.$v.form.$invalid
        }
    },
    methods: {
        ...mapActions([
            'createForumPostComment',
            'readCourseSiteByAcademicPeriod'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        resetForm () {
            this.form.body = ''
            this.$v.$reset()
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        },
        async onSubmit () {
            let loader = null
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                this.form.body = this.$sanitize(this.form.body)
                const payloadData = {
                    ...this.form,
                    courseSiteId: this.activeSite.id,
                    forumPostId: this.selectedForumPostObject.id
                }
                // Create mode
                await this.createForumPostComment(payloadData)
                this.$root.successToast(`Comentario creado exitosamente.`)
                this.resetForm()
                // Emitt event to reload the forum posts data by the parent component
                this.$emit('reloadForumPostCommentsData')
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
